import { FireScreenEvent } from '@dev-agents/analytics';
import { useIntl } from 'react-intl';
import { Redirect, useRouter } from 'react-resource-router';

import messages from './messages';

export const NotFound = () => {
	const { formatMessage } = useIntl();
	const [routeState] = useRouter();

	if (routeState.match.path === '/') {
		return <Redirect to="/" />;
	}

	return (
		<div>
			<FireScreenEvent
				name="devAgentsNotFound"
				attributes={{ attemptedPath: routeState.location.pathname }}
			/>
			{formatMessage(messages.pageTitle)}
		</div>
	);
};
